import React, { useRef, useEffect } from "react";
import videojs from "video.js";
import "../../assets/videojs-plus/videojs-plus.es";

const defaultPlayerOptions = {
  autoplay: true,
  muted: true,
  aspectRatio: "16:9",
  mobileView: false,
};

function Player({
  children,
  src,
  onPlayerInit,
  onPlayerDispose,
  videoDetails,
  defaultPaused,
  defaultMuted,
  loop,
}: any) {
  const containerRef = useRef(null as any);
  const playerOptions = {
    title: " ",
    sources: [
      {
        src,
      },
    ],
    noUITitleAttributes: true,
    plugins: {
      hotkeys: {
        volumeStep: 0.1,
        seekStep: 5,
        enableModifiersForNumbers: false,
      },
    },
    videoDetails,
    defaultMuted,
    defaultPaused,
    autoplay: !defaultPaused,
    loop,
  };
  useEffect(() => {
    window.document.addEventListener("CHAT_CLICKED", handleEvent, false);

    function handleEvent(e: any) {
      console.log("here");
    }
  }, []);
  useEffect(() => {
    if (containerRef.current) {
      const videoEl = containerRef.current.querySelector("video");
      const player: any = videojs(videoEl, {
        ...defaultPlayerOptions,
        ...playerOptions,
      });

      // used to move children component into player's elment
      // your may not thest script
      const playerEl = player.el();
      const flag = player.getChild("PlayToggleLayer").el();
      for (const child of containerRef.current.children) {
        if (child !== playerEl) {
          playerEl.insertBefore(child, flag);
        }
      }

      // ----
      onPlayerInit && onPlayerInit(player);

      // for debug purpose
      // @ts-ignore
      window.player = player;

      return () => {
        onPlayerDispose && onPlayerDispose(null);
        player.dispose();
      };
    }
  }, [onPlayerInit, onPlayerDispose, playerOptions]);

  return (
    <div className="player" ref={containerRef}>
      <video />
      {children}
    </div>
  );
}

export default Player;
